function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _JSXStyle from "styled-jsx/style";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import PropTypes from 'prop-types';
import React from 'react';
import Fecha from 'fecha'; // TODO replace with date-fns/parse after v2 is released

import Nav from "./Nav";
import NavItem from "./NavItem";
import NavLink from "./NavLink";
import Col from "./Col";
import Row from "./Row";
import mod from "../util/mod.js";
import range from "../util/range";
var format = Fecha.format;

var Label = function Label(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;
  return /*#__PURE__*/React.createElement(NavItem, {
    className: !visible ? 'invisible' : ''
  }, /*#__PURE__*/React.createElement(NavLink, {
    active: selected,
    className: "text-center py-1 px-2",
    color: "primary",
    onClick: onClick,
    outline: true,
    style: {
      cursor: 'pointer',
      listStyle: 'none'
    }
  }, label));
};

Label.displayName = "Label";
Label.propTypes = {
  selected: PropTypes.bool,
  label: PropTypes.node,
  onClick: PropTypes.func,
  visible: PropTypes.bool
};

var MonthCalendar = /*#__PURE__*/function (_React$Component) {
  _inherits(MonthCalendar, _React$Component);

  var _super = _createSuper(MonthCalendar);

  function MonthCalendar() {
    var _this;

    _classCallCheck(this, MonthCalendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getMonths = function (date) {
      return range(0, 12).map(function (month) {
        return new Date(date.getFullYear(), month, 1);
      });
    };

    _this.getYears = function (date) {
      var now = new Date();
      var currentYear = date.getFullYear();
      var month = date.getMonth();
      var end = currentYear + mod(now.getFullYear() - currentYear, 12) + 1;
      var start = end - 12;
      return range(start, end).map(function (year) {
        return new Date(year, month, 1);
      });
    };

    return _this;
  }

  _createClass(MonthCalendar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          date = _this$props.date,
          dateVisible = _this$props.dateVisible,
          monthFormat = _this$props.monthFormat,
          onSelect = _this$props.onSelect,
          yearFormat = _this$props.yearFormat;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "jsx-1971338510" + " " + "rg-MonthCalendar"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "no-gutters"
      }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Nav, {
        pills: true,
        className: "d-block p-1 m-0",
        style: {
          columnCount: 2,
          columnGap: 0
        }
      }, this.getMonths(date).map(function (monthYear, i) {
        return /*#__PURE__*/React.createElement(Label, {
          selected: date.getMonth() === monthYear.getMonth(),
          label: format(monthYear, monthFormat),
          date: monthYear,
          key: i,
          onClick: function onClick() {
            return dateVisible(monthYear) && onSelect(monthYear);
          },
          visible: dateVisible(monthYear)
        });
      }))), /*#__PURE__*/React.createElement(Col, {
        className: "border-left"
      }, /*#__PURE__*/React.createElement(Nav, {
        pills: true,
        className: "d-block p-1 m-0",
        style: {
          columnCount: 2,
          columnGap: 0
        }
      }, this.getYears(date).map(function (monthYear, i) {
        return /*#__PURE__*/React.createElement(Label, {
          selected: date.getFullYear() === monthYear.getFullYear(),
          label: format(monthYear, yearFormat),
          date: monthYear,
          key: i,
          onClick: function onClick() {
            return dateVisible(monthYear) && onSelect(monthYear);
          },
          visible: dateVisible(monthYear)
        });
      }))))), /*#__PURE__*/React.createElement(_JSXStyle, {
        id: "1971338510"
      }, ".rg-MonthCalendar.jsx-1971338510{min-width:16em;}"));
    }
  }]);

  return MonthCalendar;
}(React.Component);

MonthCalendar.propTypes = {
  date: PropTypes.instanceOf(Date),
  dateVisible: PropTypes.func,
  monthFormat: PropTypes.string.isRequired,
  yearFormat: PropTypes.string.isRequired,
  onSelect: PropTypes.func
};
MonthCalendar.defaultProps = {
  date: new Date(),
  dateVisible: function dateVisible() {
    return true;
  },
  monthFormat: 'MMM',
  yearFormat: 'YYYY',
  onSelect: function onSelect() {}
};
MonthCalendar.displayName = "MonthCalendar";
export { MonthCalendar as default };